<template>
	<VuePageNotFound />
</template>
<script>
import { applyReactInVue } from 'vuereact-combined';

import { PageNotFound } from '@/react_app/components/Pages/PageNotFound';
const VuePageNotFound = applyReactInVue(PageNotFound);
export default { name: 'PageNotFound', components: { VuePageNotFound } };
</script>
